export const FACE_DEPTH_OFFSET = 1;
// Further back than the faces, so the floor never draws over one lying on or
// just above it.
export const FLOOR_DEPTH_OFFSET = 2;
